// 기사 이미지 경로 → 화면에 쓸 URL.
//
// 같은 이미지가 여러 형태로 돌아다닌다. 한 곳에 모아 두지 않으면 붙이는 걸 잊는다.
//   1) https://…/tmp/123.png        방금 올린 임시 이미지(절대 URL)
//   2) /news/photo/YYYYMM/x.jpg     저장된 본문에서 되읽은 것
//   3) YYYYMM/x.jpg                 article_photo.filepath (DB 형식)
//
// 실제 파일은 news/photo/YYYYMM/ 아래에 있으므로 3) 은 photo/ 를 붙여야 한다.
// DB 에 photo/ 를 넣지 않는 이유는 이관분 106,286건과 형식을 맞추기 위해서다.
//
// 도메인을 붙이지 않고 상대경로로 두는 게 중요하다. CMS 의 /news/ 라우트가
// 로컬(public/news) → CDN → 옛 사이트 순으로 찾아 준다. 예전에 여기에
// cdn.jasm.co.kr(옛 사이트)을 하드코딩해서 신규 업로드가 전부 깨졌다.
export function imageUrl(img) {
  if (!img) return '';
  if (/^https?:\/\//i.test(img)) return img;
  var s = String(img).replace(/^\/+/, '');
  if (s.indexOf('news/') === 0) return '/' + s;
  // article.thumb 은 두 형식이 섞여 있다.
  //   신규: thumbnail/YYYYMM/{base}_300.jpg   ← 썸네일 파이프라인 산출물
  //   이관: YYYYMM/{file}.jpg                 ← 원본 경로
  // photo/ 를 무조건 붙이면 신규가 /news/photo/thumbnail/... 이 되어 어디에도 없는
  // 경로가 된다. 배치 페이지에서 "신규·수정 기사만 썸네일이 안 보이는" 원인이었다.
  if (s.indexOf('thumbnail/') === 0) return '/news/' + s;
  return '/news/photo/' + s.replace(/^photo\//, '');
}

// 본문 이미지에서 만들어진 썸네일. 서버가 news/thumbnail/YYYYMM/{base}_{w}.jpg 로
// 150·300·500·640 을 만들어 둔다(writeArticles.js 의 THUMB_SIZES).
// 🔴 `v` 를 주면 `?v=` 로 붙인다. 썸네일 파일 이름은 규격마다 고정이라
//    자름 설정을 바꿔 다시 만들어도 URL 이 같고, 그러면 편집자 브라우저가
//    **옛 그림을 계속 보여 준다**(2026-09-29 지적). 미리보기처럼 '지금 만든 것'을
//    봐야 하는 자리에서는 Date.now() 를 넘긴다.
export function thumbnailUrl(img, w, v) {
  var s = String(img || '').replace(/^\/+/, '').replace(/^news\//, '').replace(/^photo\//, '');
  var m = s.match(/^(\d{6})\/(.+)\.[^.]+$/);
  if (!m) return '';
  return '/news/thumbnail/' + m[1] + '/' + m[2] + '_' + w + '.jpg' + (v ? '?v=' + v : '');
}
